// extracted by mini-css-extract-plugin
export default {"spacePie":"Knob_spacePie__LvhjB","messageError":"Knob_messageError__lY211"};